import { useQuery } from "@tanstack/react-query";
import { fetchLegacyAccountAnchor } from "@/api/clients";

/** A-Block A0 — resolve a legacy account id to its holding anchor for redirect. */
export function useLegacyAccountAnchor(accountId: string | undefined) {
  return useQuery({
    queryKey: ["legacy-account-anchor", accountId],
    queryFn: ({ signal }) => fetchLegacyAccountAnchor(accountId as string, signal),
    enabled: !!accountId,
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
}
